// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"X_fG","bannerContainer":"X_fH","bannerImage":"X_fJ","bannerTitle":"X_fK","bannerDescription":"X_fL","bannerButton":"X_fM"};